import Vue from "vue";
import Toast from "./toast.vue";
 // 使用  this.$toast.xxx ('message') 
let ToastConstructor = Vue.extend(Toast); // 构造函数
let instance; // 实例对象 
let seed = 1; // 计数 

const ToastDialog = (options = {}) => {
  if (typeof options === "string") {
    options = {
      message: options,
      type: "info"
    };
  }
  let id = `toast_${seed++}`;
  instance = new ToastConstructor({
    data: options
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 3000 + seed;
  return instance.vm;
};
ToastDialog.success = (options = {}) => {
  if (typeof options === "string") {
    options = {
      message: options,
      type: "success"
    };
  }
  let id = `toast_${seed++}`;
  instance = new ToastConstructor({
    data: options
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 3000 + seed;
  return instance.vm;
};
ToastDialog.error = (options = {}) => {
  if (typeof options === "string") {
    options = {
      message: options,
      type: "error"
    };
  }// 
  let id = `toast_${seed++}`;
  instance = new ToastConstructor({
    data: options
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 3000 + seed;
  return instance.vm;
};
ToastDialog.warning = (options = {}) => {
  if (typeof options === "string") {
    options = {
      message: options,
      type: "warning"
    };
  }
  let id = `toast_${seed++}`;
  instance = new ToastConstructor({
    data: options,
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 3000 + seed;
  return instance.vm;
};
ToastDialog.info = (options = {}) => {
  if (typeof options === "string") {
    options = {
      message: options,
      type: "info"
    };
  }
  let id = `toast_${seed++}`;
  instance = new ToastConstructor({
    data: options
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 3000 + seed;
  return instance.vm // 
};

export default ToastDialog;



// WEBPACK FOOTER //
// ./src/components/toast/toast.js